import { render, staticRenderFns } from "./Samsung.vue?vue&type=template&id=5d34281e&scoped=true&"
import script from "./Samsung.vue?vue&type=script&lang=js&"
export * from "./Samsung.vue?vue&type=script&lang=js&"
import style0 from "./Samsung.vue?vue&type=style&index=0&id=5d34281e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d34281e",
  null
  
)

export default component.exports